








import { Component, Vue, Prop } from "vue-property-decorator";
import * as _ from "lodash";
@Component({
  components: {}
})
export default class H5Biaoti extends Vue {
  @Prop()
  private ziduan: any;
  @Prop()
  private index: any;
}
